import {ReactNode} from 'react'
import {Col, Row} from 'react-bootstrap'
import {GrAttachment} from 'react-icons/gr'
import {Modal} from 'rsuite'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import {imageBaseUrl} from 'src/cms/helpers/constants'

type Props = {
  data: {
    id: String
    created_at: string
    grievanceCode: String
    fullName: String
    email: String
    department: {
      id: String
      name: String
      nameNp: String
    } | null
    attachments: String | null
    mobileNumber: String
    message: String
    accountNumber: String
    preferredBranch:
      | [
          {
            id: String
            name: String
          }
        ]
      | null
    serviceCategory: {
      id: String
      name: String
    } | null
    serviceType: {
      id: String
      name: String
    } | null
    serviceSubType: {
      id: String
      name: String
    } | null
    status: {
      id: String
      name: String
      created_at: String
      updated_at: String
      remarks: String
    } | null
  }
  handleClose: () => void
}

const Section = ({title, children}: {title: string; children: ReactNode}) => (
  <div className='mb-6'>
    <h6 className='text-uppercase text-muted fs-7 fw-bold mb-3 pb-2 border-bottom'>{title}</h6>
    {children}
  </div>
)

const Field = ({label, value}: {label: string; value: ReactNode}) => (
  <Row className='mb-2'>
    <Col sm={4} className='fw-bold text-gray-700'>
      {label}
    </Col>
    <Col sm={8} className='text-break'>
      {value || 'N/A'}
    </Col>
  </Row>
)

const ViewGrievanceDetails = ({data, handleClose}: Props) => {
  const grievanceHandingHideAssignedToFieldInDetailsModal = checkBackendSetting(
    'grievanceHandingHideAssignedToFieldInDetailsModal'
  )
  const service = [data?.serviceCategory?.name, data?.serviceType?.name, data?.serviceSubType?.name]
    .filter(Boolean)
    .join(' › ')

  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        size='md'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>
            Grievance Details
            {data?.grievanceCode && (
              <span className='text-muted fs-6 fw-normal ms-2'>#{data.grievanceCode}</span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Section title='Complainant'>
            <Field label='Full Name' value={data?.fullName} />
            <Field label='Email' value={data?.email} />
            <Field label='Contact Number' value={data?.mobileNumber} />
            <Field label='Account Number' value={data?.accountNumber} />
            <Field label='Created At' value={data?.created_at} />
          </Section>

          <Section title='Grievance'>
            {service && <Field label='Service' value={service} />}
            {!grievanceHandingHideAssignedToFieldInDetailsModal && (
              <Field label='Assigned To' value={data?.department?.name} />
            )}
            <Field
              label='Status'
              value={
                data?.status?.name && (
                  <span className='badge badge-light-primary'>{data.status.name}</span>
                )
              }
            />
            <Field
              label='Status Date'
              value={data?.status?.updated_at || data?.status?.created_at}
            />
            {data?.status?.remarks && <Field label='Remarks' value={data.status.remarks} />}
            {data?.attachments && (
              <Field
                label='Attachment'
                value={
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href={imageBaseUrl + '/' + data.attachments}
                    className='d-inline-flex align-items-center gap-1'
                  >
                    <GrAttachment /> View attachment
                  </a>
                }
              />
            )}
          </Section>

          <Section title='Message'>
            <div
              className='bg-light rounded p-4 text-gray-800'
              style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.6}}
            >
              {data?.message || 'N/A'}
            </div>
          </Section>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewGrievanceDetails
